export default {
  groupName: 'auto-dashboard-demo',
  appName: 'Auto Dashboard Demo',
  baseRoute: '/dashboard/auto-dashboard-demo',
  label: 'Auto AdPi Dashboard (Demo)',
  home: '/slicer',
  image: 'demo.png',
  description: 'Automotiove AdPi Dashboard (Demo)'
};



// WEBPACK FOOTER //
// ./src/app/configuration/Demo/AutoDashboard/config/main.js